import { GenericAlert, GenericCheckBox } from "@studio3t/generic-components";
import { SelectDropdown, type SelectOption } from "./SelectDropdown";
import {
  CheckboxBlock,
  CheckboxHelpText,
  DefaultModelGroup,
  FieldRow,
  FieldRowControl,
  Label,
  LlmSetup,
} from "./styles";

export type LlmProvider = "anthropic" | "bedrock" | "openai";

export const AI_PROVIDER_OPTIONS: SelectOption<LlmProvider>[] = [
  { value: "anthropic", label: "Anthropic (Claude)" },
  { value: "bedrock", label: "AWS Bedrock" },
  // { value: "openai", label: "OpenAI" }, // Not yet wired on the backend
];

interface LlmFieldsProps {
  aiProvider: LlmProvider;
  setAiProvider: (value: LlmProvider) => void;
  // The default-model box (see defaultModelChoice): it is locked while the
  // LLM list loads and for the first LLM, when the alert explains why.
  checked: boolean;
  disabled: boolean;
  onCheckedChange: (value: boolean) => void;
  showLockedHint: boolean;
  providerFields: JSX.Element;
}

// The LLM provider card (Figma 14063-31987 Anthropic, 14063-32729 Bedrock):
// AI provider picker and default-model checkbox above the chosen provider's
// configuration section.
export function LlmFields({
  aiProvider,
  setAiProvider,
  checked,
  disabled,
  onCheckedChange,
  showLockedHint,
  providerFields,
}: LlmFieldsProps) {
  return (
    <>
      <LlmSetup>
        <FieldRow>
          <Label as="span">AI provider</Label>
          <FieldRowControl>
            <SelectDropdown
              value={aiProvider}
              options={AI_PROVIDER_OPTIONS}
              onChange={setAiProvider}
            />
          </FieldRowControl>
        </FieldRow>

        <DefaultModelGroup>
          <CheckboxBlock>
            <GenericCheckBox
              label="Set this model as default"
              value={checked}
              disabled={disabled}
              onChange={onCheckedChange}
              testId="llm-set-default"
            />
            <CheckboxHelpText $disabled={disabled}>
              This is the default model used by the Agent and the AI Helper.
            </CheckboxHelpText>
          </CheckboxBlock>
          {showLockedHint && (
            <GenericAlert
              state="Info"
              icon
              dismissible={false}
              width="100%"
              message="This option will be available as soon as more than one provider is added."
            />
          )}
        </DefaultModelGroup>
      </LlmSetup>

      {providerFields}
    </>
  );
}
